import common from "./common.json";

const RateRangeLangConfig = {
  common,
};

export default RateRangeLangConfig;
